import { Grid } from "@mui/material";
import StatisticCard from "src/components/StatisticCard/StatisticCard";
import useLocales from "src/hooks/useLocales";

import useGetStatisticsData from "./services/useGetStatisticsData";

// ----------------------------------------------------------------------

export const StatisticsGrid = () => {
	const { mtd, ytd, day, total } = useGetStatisticsData();
	const { translate } = useLocales();

	return (
		<Grid container spacing={3} sx={{ mt: { xs: -1, sm: 0 } }}>
			<Grid item lg={3} xs={12}>
				<StatisticCard
					title={translate("overview.total_connections")}
					icon={"solar:global-bold-duotone"}
					color={"primary"}
					value={total}
				/>
			</Grid>
			<Grid item lg={3} xs={12}>
				<StatisticCard
					title={translate("overview.ytd_connections")}
					icon={"ion:calendar"}
					color={"success"}
					value={ytd}
				/>
			</Grid>
			<Grid item lg={3} xs={12}>
				<StatisticCard
					title={translate("overview.mtd_connections")}
					icon={"lets-icons:pie-chart-fill"}
					color={"bluePurple"}
					value={mtd}
				/>
			</Grid>
			<Grid item lg={3} xs={12}>
				<StatisticCard
					title={translate("overview.day_connections")}
					icon={"fluent:calendar-today-20-filled"}
					color={"blue"}
					value={day}
				/>
			</Grid>
		</Grid>
	);
};

export default StatisticsGrid;
